import { clsx } from 'clsx'
import { useLocation } from 'react-router'

import { useFvNavigate } from '@fv/client-components'
import type { PropsWithClassName, SelectFieldOption } from '@fv/client-types'
import type { ShipmentSortType } from '@fv/models'

import { SelectField } from '@/components/inputs/SelectField'

import { useRole } from '../auth/hooks'

type Props = PropsWithClassName<{
  includeBooked?: boolean
  value: ShipmentSortType
}>

export const ShipmentSortSelect = ({
  value,
  className,
  includeBooked,
}: Props) => {
  const { pathname, search } = useLocation()
  const navigate = useFvNavigate()
  const role = useRole()

  const options: SelectFieldOption<ShipmentSortType>[] = [
    {
      text: 'Pickup date',
      value: 'pickupDate',
    },
    {
      text: 'Created',
      value: 'createdDate',
    },
    ...(includeBooked
      ? [
          {
            text: 'Booked date',
            value: 'bookedDate' as const,
          },
        ]
      : []),
    ...(role !== 'vendor'
      ? [
          {
            text: 'Messages',
            value: 'messageDate' as const,
          },
        ]
      : []),
  ]

  const handleSelect = (val: ShipmentSortType) => {
    if (val === value) return

    const params = new URLSearchParams(search)
    params.set('sortBy', val)
    params.delete('load')
    navigate(`${pathname}?${params.toString()}`)
  }

  return (
    <SelectField
      aria-label="Sort shipments by"
      className={clsx('w-full ml-1', className)}
      options={options}
      name="sortBy"
      value={value}
      onChange={e => handleSelect(e.target.value as ShipmentSortType)}
    />
  )
}
